import { ethers } from 'ethers';
import { TaskEscrowABI } from '../../ABI/ABI';

const ESCROW_CREATED_EVENTS = ['JobEscrowCreated', 'JobAssignmentCreated', 'EscrowCreated'];

export const extractEscrowIdFromReceipt = (receipt) => {
    const contractInterface = new ethers.Interface(TaskEscrowABI);
    for (const log of receipt.logs || []) {
        try {
            const parsedLog = contractInterface.parseLog({
                data: log.data,
                topics: [...log.topics],
            });
            if (ESCROW_CREATED_EVENTS.includes(parsedLog?.name)) {
                return Number(parsedLog.args.escrowId).toString();
            }
        } catch (error) {
            continue;
        }
    }
    return '';
};
